module.exports = __webpack_public_path__ + "img/note-icon-gray.59a60faa.svg";